// Central content & contact config — edit here to change site-wide info

export const CONTACT = {
  storeName: "Shibuya Anime & TCG Store",
  companyName: "C&Y Shibuya Store UG (haftungsbeschränkt)",
  manager: "Mert Cingoez, Ufuk Yildirim",
  registerCourt: "Amtsgericht Köln",
  hrb: "HRB 122800",
  phoneDisplay: "0221 96260815",
  phoneHref: "tel:+4922196260815",
  whatsappHref:
    "https://wa.me/4915562629330?text=Hi%20Shibuya%20Store!%20Ich%20habe%20eine%20Frage.",
  email: "info@shibuya-store.de",
  emailHref: "mailto:info@shibuya-store.de",
  instagram: "https://www.instagram.com/shibuya.animestore/",
  tiktok: "https://www.tiktok.com/@shibuya.animestore",
  addressStreet: "Zülpicherstr. 357",
  addressCity: "50935 Köln",
  mapsHref:
    "https://www.google.com/maps/search/?api=1&query=Shibuya+Anime+%26+TCG+Store+Z%C3%BClpicherstr.+357+50935+K%C3%B6ln",
  mapsEmbed:
    "https://www.google.com/maps?q=Z%C3%BClpicher%20Str.%20357%2C%2050935%20K%C3%B6ln&output=embed",
  vatId: "DE453860907",
};

export const LOGO = "/assets/logo.png";

// Sortiment-Navigation (lokale SEO-Landingpages)
export const SORTIMENT = [
  { to: "/pokemon-karten-koeln", label: "Pokémon Karten", jp: "ポケモン" },
  { to: "/one-piece-karten-koeln", label: "One Piece Karten", jp: "海賊" },
  { to: "/yugioh-karten-koeln", label: "Yu-Gi-Oh! Karten", jp: "遊戯" },
  { to: "/anime-figuren-koeln", label: "Anime Figuren", jp: "フィギュア" },
  { to: "/tcg-zubehoer-koeln", label: "TCG Zubehör", jp: "用品" },
];

export const SITE_URL = "https://shibuya-store.de";

export const HOURS = [
  { days: "Montag – Freitag", time: "12:00 – 20:00 Uhr" },
  { days: "Samstag", time: "10:00 – 20:00 Uhr" },
  { days: "Sonntag", time: "Geschlossen" },
];

export const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const IMAGES = {
  heroArt: "/assets/hero-art.jpg",
  tcgCards: "/assets/tcg.jpg",
  figures: "/assets/figures.jpg",
  community: "/assets/community.jpg",
  tokyoNeonStreet:
    "https://images.unsplash.com/photo-1542051841857-5f90071e7989?w=1600&q=80",
};

// Wiederkehrende Event-Formate (statisch) – echte Termine kommen aus der API (/api/events)
export const EVENT_FORMATS = [
  {
    id: "trade-day",
    tag: "Trade Day",
    title: "Shibuya Trade Day",
    description:
      "Der Klassiker: Bring deine Karten mit und trade mit anderen Sammlern aus Köln und Umgebung. Egal ob Pokémon, One Piece oder andere TCGs – hier findest du Tauschpartner auf jedem Level.",
    highlights: ["Karten tauschen & traden", "Sammlung bewerten lassen", "Neue Leute kennenlernen"],
    accent: "primary",
    kanji: "交換",
  },
  {
    id: "release-events",
    tag: "Release",
    title: "Set-Release Events",
    description:
      "Neue Sets feiern wir gemeinsam: Sei bei Release-Tagen dabei, sichere dir die neuesten Produkte und öffne deine ersten Packs direkt im Store.",
    highlights: ["Neueste Produkte zuerst", "Pack-Opening gemeinsam", "Limitierte Stückzahlen"],
    accent: "accent",
    kanji: "発売",
  },
];

export const formatEventDate = (isoDate) => {
  try {
    return new Date(`${isoDate}T00:00:00`).toLocaleDateString("de-DE", {
      weekday: "short",
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  } catch {
    return isoDate;
  }
};
